import { Items } from 'src/app/core/models/common/items.model';
import { IMAGE_SRC, STATUS_OPTIONS } from '../../../shared-constants';

export const IDO_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const IDO_ICONS_WITH_WARNING: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.SUSPENDED, src: IMAGE_SRC.YIELD, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];
